var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57668 6.39723C5.17717 6.94316 4.36219 6.94316 3.96268 6.39723L0.445201 1.59055C-0.0382513 0.929914 0.433558 1.40524e-07 1.2522 2.0828e-07L8.28717 7.90544e-07C9.10581 8.58301e-07 9.57762 0.929914 9.09416 1.59056L5.57668 6.39723Z",
    fill: "#F15B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.e5048570dc9dbe2b282d10d5045f4095.svg";
export { ForwardRef as ReactComponent };